import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { isProductionEnvironment } from "utils/env";
import { TableColumnMeta } from "ds/components/Table/types";
import makeTableColumnsSlice from "ds/components/Table/store/useTableStore/makeTableColumnsSlice";

import makeIacTableDataSlice from "./makeIacTableDataSlice";
import { IacTableStoreState } from "./types";

type MakeIacTableStoreInitProps = {
  storageKey: string;
  initialColumns: Record<TableColumnMeta["id"], TableColumnMeta>;
};

const makeIacTableStore = ({ storageKey, initialColumns }: MakeIacTableStoreInitProps) =>
  create<IacTableStoreState>()(
    devtools(
      persist(
        immer((...a) => ({
          ...makeTableColumnsSlice<IacTableStoreState>(initialColumns)(...a),
          ...makeIacTableDataSlice(...a),
        })),
        {
          name: storageKey,
          version: 3,
          partialize: (state) => ({
            columnsSizes: state.columnsSizes,
            columnsOrder: state.columnsOrder,
            isFirstColumnPinned: state.isFirstColumnPinned,
          }),
          merge: (persistedState, currentState) => ({
            ...currentState,
            ...(persistedState as Partial<IacTableStoreState>),
          }),
        }
      ),
      { enabled: !isProductionEnvironment() }
    )
  );

export default makeIacTableStore;
